import { Infoblock } from '@main/infoblock/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';

export const INFOBLOCK = '[Main Layout] Infoblock';
export const LOAD_INFOBLOCKS = '[Main Layout] Load Infoblocks';
export const LOAD_INFOBLOCKS_SUCCESS = '[Main Layout] Load Infoblocks Success';
export const LOAD_INFOBLOCKS_FAIL = '[Main Layout] Load Infoblocks Fail';
export const CLOSE_INFOBLOCKS = '[Main Layout] Close Infoblocks';

export class LoadInfoblocks extends StateUtils.EntityLoadAction {
  readonly type = LOAD_INFOBLOCKS;

  constructor(public cityId: string) {
    super(INFOBLOCK, cityId);
  }
}

export class LoadInfoblocksSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_INFOBLOCKS_SUCCESS;

  constructor(
    public cityId: string,
    payload: Infoblock[],
  ) {
    super(INFOBLOCK, cityId, payload);
  }
}

export class LoadInfoblocksFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_INFOBLOCKS_FAIL;

  constructor(
    public cityId: string,
    payload: any,
  ) {
    super(INFOBLOCK, cityId, payload);
  }
}

export class CloseInfoblocks implements Action {
  readonly type = CLOSE_INFOBLOCKS;

  constructor(public payload: string[]) {}
}

export type InfoblockAction = CloseInfoblocks | LoadInfoblocks;
